import { useEffect, useState } from 'react';
import { FormControl, FormLabel } from '@mui/material';

import useDebounce from 'Lib/hooks/useDebounce';
import isEmpty from 'Lib/utilities/isEmpty';
import unique from 'Lib/utilities/unique';

import Select from './Select';

export default function SelectFilter({ optionPath, value, createOption, placeholder, label, disabled, ...rest }) {
    const [renderCount, setRenderCount] = useState(1);
    const [options, setOptions] = useState(rest.options);
    const [inputValue, setInputValue] = useState('');
    const [defaultSelected, setDefaultSelected] = useState(rest.multi ? [] : null);
    const [optionsSelected, setOptionsSelected] = useState([]);

    const debouncedValue = useDebounce(inputValue, 500);

    useEffect(() => {
        if (value) {
            const selected = rest.options.filter(option => {
                const optionValue = option.value.toString();
                const valueArray = Array.isArray(value) ? value : [value];
                return valueArray.some(val => val.toString() === optionValue);
            });

            setDefaultSelected(rest.multi ? selected : selected[0]);
            setRenderCount(renderCount + 1);
        }
    }, []);

    useEffect(() => {
        if (!isEmpty(debouncedValue)) {
            const existingValues = rest.multi ? defaultSelected : defaultSelected ? [defaultSelected] : [];
            const selectedValues = Array.isArray(optionsSelected) ? optionsSelected : [optionsSelected];
            const uniqueOptions = unique([...existingValues, ...selectedValues, ...options], optionPath);

            if (createOption) {
                setOptions(
                    uniqueOptions.map(option => {
                        if (option.label && option.value) return option;
                        return createOption(option);
                    })
                );
            } else setOptions(uniqueOptions);
        }
    }, [debouncedValue]);

    return (
        <FormControl fullWidth disabled={disabled}>
            {label && <FormLabel id={`${label}-filter`}>{label}</FormLabel>}
            <Select
                {...rest}
                key={renderCount}
                value={value}
                placeholder={placeholder ?? `Type to search ${label.toLowerCase()}`}
                disableCloseOnSelect={rest.multi ? true : false}
                limitTags={1}
                options={options}
                defaultValue={defaultSelected}
                getOptionLabel={option => option.label}
                onTextChange={event => setInputValue(event.target.value)}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onSelectedOption={val => {
                    let selected = val;
                    if (val && Array.isArray(val) && val.length) {
                        selected = val.length > 1 ? val.map(option => option.value.toString()).sort() : val[0].value.toString();
                    } else if (val && !Array.isArray(val) && val.value) selected = val.value.toString();

                    setOptionsSelected(val);
                    rest.onChange(rest.name, selected);
                }}
            />
        </FormControl>
    );
}
